import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Navbar = ({ scrollToContact }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const getNavClasses = () => {
    if (isScrolled) {
      return 'bg-white/80 backdrop-blur-md py-4 shadow-sm';
    }
    return 'bg-transparent py-6';
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${getNavClasses()}`}>
      <div className="container mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <div className="flex flex-col items-start z-50 cursor-pointer" onClick={handleLogoClick}>
          <img 
            src="https://karinesilva.ca/wp-content/uploads/2023/11/karine-silva-logo-gris.png" 
            alt="Karine Silva Logo" 
            className="h-14 w-auto object-contain mb-2" 
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;